import { combineReducers } from 'redux';

import apiError from './apiError';
import extension from './extension';
import isLoading from './isLoading';

/**
 * @typedef {{
 *   apiError: import('./apiError').State,
 *   isLoading: import('./isLoading').State,
 *   extension: import('./extension').State,
 * }} NotificationUIConfigurationReducer
 */

export default combineReducers({
  isLoading,
  extension,
  apiError,
});
